import withStyles from "isomorphic-style-loader/withStyles";
import React from "react";
import styles from "../../styles.scss";
import { FormControlLabel, Switch } from "@mui/material";
import { Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareNodes } from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

interface SocialMediaInputProps {
  isEnabled: boolean;
  setIsEnabled: (value: boolean) => void;
  label: string;
  value: string;
  setValue: (value: string) => void;
  icon?: IconDefinition;
}

const SocialMediaInput = ({
  isEnabled,
  setIsEnabled,
  label,
  value,
  setValue,
  icon = faShareNodes,
}: SocialMediaInputProps) => {
  return (
    <div style={{ margin: "15px 0" }}>
      <FormControlLabel
        control={
          <Switch checked={isEnabled} onChange={e => setIsEnabled(!isEnabled)} />
        }
        label={<Label className={styles.switchLabel} onClick={e => setIsEnabled(!isEnabled)}>{label}</Label>}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <FontAwesomeIcon icon={icon} style={{ margin: "8px", fontSize: "24px" }} />
        <Input
          type="text"
          value={value}
          onChange={e => setValue(e.target.value)}
          disabled={!isEnabled}
          className={styles.input}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(SocialMediaInput);
